export class DocumentTemplate{
    _id?: string;
    name?: string;
    owner?: string;
    company?: string;
    createdAt?: Date;
    updatedAt?: Date;
    // v2 fields
    project?: string;
    contextType?: string;
    templateJson?: any;
  }